import { render, staticRenderFns } from "./ai-test.vue?vue&type=template&id=4abfc566"
import script from "./ai-test.vue?vue&type=script&lang=js"
export * from "./ai-test.vue?vue&type=script&lang=js"
import style0 from "./ai-test.vue?vue&type=style&index=0&id=4abfc566&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports